import useMonolithApiQuery from '@/hooks/api/useMonolithApiQuery';
import { BuildCacheInfo } from '@/models/BuildCacheInfo';
import { buildCacheCacheInfo } from '@/utils/monolithApiRouteService';

type UseBuildCacheCacheInfoProps = {
  slug: string;
  initialData?: BuildCacheInfo;
  enabled: boolean;
};

const useBuildCacheCacheInfo = ({ slug, initialData, enabled }: UseBuildCacheCacheInfoProps) =>
  useMonolithApiQuery<BuildCacheInfo, unknown>(['build', slug, 'cache-info'], buildCacheCacheInfo(slug), {
    enabled,
    initialData: initialData ? { data: initialData } : undefined,
  });

export default useBuildCacheCacheInfo;
